import { Button, Dropdown, MenuProps } from 'antd';
import CreateServiceHeader from 'components/common/tables_header/create_service_header';
import useMember from 'hooks/useMember';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
type CreateServiceTableProps = {
  createService: boolean;
  addService: (data) => void;
  usersData: any;
  departmentList: any;
  setService: (status: boolean) => void;
};

const items: MenuProps['items'] = [
  {
    key: '1',
    label: 'Delete',
    icon: (
      <img
        src={'/icons/delete_icon.svg'}
        alt={'login'}
        width={20}
        height={20}
      />
    ),
  },
];

const CreateServiceTable = ({
  departmentList,
  createService,
  addService,
  usersData,
  setService,
}: CreateServiceTableProps) => {
  const { getManagers, getServiceList } = useMember();
  const serviceData = useQuery('get-list-services', getServiceList);
  // const [serviceData, setServiceData] = useState([]);
  // console.log(serviceData);

  const [selectDepartment, setSelectDepartment] = useState(null);
  const [nameManager, setNameManager] = useState('');
  // const onDelete = (id: string) => {
  //   setServiceData(serviceData.filter((item) => item.id !== id));
  //   DELETE(`/api/service/delete/?ids=${id}`);
  // };
  useEffect(() => {
    const t =
      departmentList && departmentList.length > 0 && departmentList[0].id;
    getManagers({
      department_id: selectDepartment === null ? t : selectDepartment,
      role: 'department_manager',
    }).then((res) => {
      addService({ manager_id: parseInt(res?.data?.results[0].id) });
      setNameManager(
        res?.data?.results[0].first_name +
        ' ' +
        res?.data?.results[0].last_name,
      );
    });
  }, [selectDepartment, departmentList]);
  useEffect(() => {
    const t =
      departmentList && departmentList.length > 0 && departmentList[0].id;
    addService({ department_id: t });
  }, [departmentList]);

  useEffect(() => {
    // setServiceData(serviceList?.data?.data);
    // getServiceList().then((res) => {
    //   setServiceData(res?.data);
    // });
  }, []);

  return (
    <div style={{ overflowX: 'auto', padding: 5 }}>
      <div
        style={{
          width: '100%',
          marginBottom: 100,
          overflowX: 'auto',
        }}
        className="employee_directory_filter_table"
      >

        <tbody>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              borderBottom: '0.5px solid #407FDD',
              height: 60
              // , width: '100%'
            }}
          >
            <img
              onClick={() => {
                const timeoutId = setTimeout(() => {
                  const targetElement = document.getElementById("new-service");
                  if (targetElement) {
                    targetElement.scrollIntoView({
                      behavior: 'smooth',
                    });
                  }
                }, 100);
                setService(true);
                return () => clearTimeout(timeoutId);
              }}
              style={{ cursor: 'pointer', marginLeft: 32, height: 24, width: 24 }}
              src="/icons/add_department.svg"
              alt="add_department"
            />
            <div style={{ fontWeight: '500', fontSize: 20, color: '#000' }}>Service</div>
          </div>
          <div style={{ borderBottom: '0.5px solid #407FDD' }}>
            <CreateServiceHeader />
          </div>
          {serviceData?.data?.data?.map((item, index: number) => (
            <div
              key={index}
              style={{
                display: 'flex',
                marginBottom: 10,
                borderBottom: '0.5px solid #407FDD'
              }}
            >
              {/* <div>
                <Dropdown
                  menu={{
                    items,
                    onClick: (e) => {
                      console.log(item.id);
                      onDelete(item.id);
                    },
                  }}
                  placement={'topLeft'}
                >
                  <Button
                    type={'text'}
                    icon={
                      <img
                        src={'/icons/3_dots.svg'}
                        alt={'icon'}
                        width={18}
                        height={18}
                      />
                    }
                  />
                </Dropdown>
              </div> */}
              <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', padding: '0px 58px 0px 64px' }}><img
                src={'/icons/3_dots.svg'}
                alt={'icon'}
                width={18}
                height={18}
              /></div>
              <div className="common_custom_company_input" style={{ width: 218 }}>{item.name}</div>
              <div
                className="common_custom_company_input" style={{ width: 188 }}
              >
                {item.code}
              </div>
              <div
                className="common_custom_company_input" style={{ width: 218 }}
              >
                {item.department_name}
              </div>
              <div

                className="common_custom_company_input" style={{ width: 138 }}
              >
                {item.nif_code}
              </div>
              <div className="common_custom_company_input" style={{ width: 168 }}>
                {item.business_registration_code}
              </div>
              <div className="common_custom_company_input" style={{ width: 138 }}>
                {item.organization_code}
              </div>
              <div className="common_custom_company_input" style={{ width: 138 }}>
                {item.company_code}
              </div>
              <div className="common_custom_company_input" style={{ width: 148 }}>{item.address}</div>
              <div className="common_custom_company_input" style={{ width: 268 }}>
                {item.manager
                  ? item.manager.first_name + ' ' + item.manager.last_name
                  : 'Intes Admin'}
              </div>
              <div className="common_custom_company_input" style={{ width: 148 }}>{item.comments}</div>
            </div>
          ))}
          {createService && (
            <div style={{ display: 'flex', borderBottom: '0.5px solid #407FDD' }} id="new-service">
              <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', padding: '40px 52px 0px 57px' }}>
                <Dropdown
                  menu={{
                    items,
                    onClick: (e) => {
                      setService(false);
                    },
                  }}
                  placement={'topLeft'}
                >
                  <Button
                    type={'text'}
                    icon={
                      <img
                        src={'/icons/3_dots.svg'}
                        alt={'icon'}
                        width={18}
                        height={18}
                      />
                    }
                  />
                </Dropdown>
              </div>
              <input
                maxLength={50}
                onChange={(e) => addService({ name: e.target.value })}
                className="common_custom_company_input1"
                style={{ width: 218 }}
              />
              <input
                maxLength={50}
                onChange={(e) => addService({ code: e.target.value })}
                className="common_custom_company_input1"
                style={{ width: 188 }}
              />
              <div >
                <select
                  onChange={(e) => {
                    addService({ department_id: parseInt(e.target.value) });
                    setSelectDepartment(parseInt(e.target.value));
                  }}
                  className="common_custom_company_input1"
                  style={{ width: 218 }}
                  id="type"
                >
                  <option selected disabled hidden></option>
                  {departmentList?.map((item) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </select>
              </div>
              <input
                maxLength={50}
                onChange={(e) => addService({ nif_code: e.target.value })}
                className="common_custom_company_input1"
                style={{ width: 138 }}
              />
              <input
                maxLength={50}
                onChange={(e) =>
                  addService({ business_registration_code: e.target.value })
                }
                className="common_custom_company_input1"
                style={{ width: 168 }}
              />
              <input
                maxLength={50}
                onChange={(e) =>
                  addService({ organization_code: e.target.value })
                }
                className="common_custom_company_input1"
                style={{ width: 138 }}
              />
              <input
                maxLength={50}
                onChange={(e) => addService({ company_code: e.target.value })}
                className="common_custom_company_input1"
                style={{ width: 138 }}
              />
              <input
                maxLength={50}
                onChange={(e) => addService({ address: e.target.value })}
                className="common_custom_company_input1"
                style={{ width: 148 }}
              />
              <div className="common_custom_company_input" style={{ width: 268 }}>
                {/* <select
                  onChange={(e) =>
                    addService({ manager_id: parseInt(e.target.value) })
                  }
                  style={{
                    width: '100%',
                    height: 35,
                    border: '0.5px solid #73A1E7',
                  }}
                  id="type"
                >
                  {usersData?.map((item) => (
                    <option value={item.id}>
                      {item.first_name + ' ' + item.last_name}
                    </option>
                  ))}
                </select> */}
                {nameManager}
              </div>
              <input
                maxLength={50}
                onChange={(e) => addService({ comments: e.target.value })}
                className="common_custom_company_input1"
                style={{ width: 148 }}
              />
            </div>
          )}
        </tbody>
      </div>
    </div>
  );
};

export default CreateServiceTable;
